import { get as _get } from 'lodash';
import { getArgoConfig } from '../../../window';
import GqlClient from "./GqlClient";
import GqlDevClient from "./GqlDevClient";
import {getNoOfPreferences} from "../../UserPreferences";

function initialiseGqlClient(
    argoConfig: any,
    metricPublisher: any,
    authSession: any,
    authToken: string,
    region: string
): GqlClient | GqlDevClient {
    const noOfPreferences = getNoOfPreferences(argoConfig);

    if (noOfPreferences !== 0) {
        return new GqlClient(metricPublisher, authSession, authToken, region);
    } else {
        return new GqlDevClient(metricPublisher, authSession, authToken, region);
    }
}

export function getGqlClient(
    metricPublisher: any,
    authSession: any,
    authToken: string,
    region: string
): GqlClient | GqlDevClient {
    const argoConfig = getArgoConfig();
    return initialiseGqlClient(argoConfig, metricPublisher, authSession, authToken, region);
}